import React from 'react';
import { Div } from '../../../../components/grid';
import { SideMenuItem, SideMenuSpacer }  from '../SidemenuItems';

export default ({
  activeSidemenu,
}) => (
  <Div>
    <SideMenuItem to="/levering-afhentning" title="Levering &amp; afhentning" active={activeSidemenu === 'LeveringAfhentning'} />
    <SideMenuItem to="/levering-afhentning/afhentning" title="Vejledning til afhentning" active={activeSidemenu === 'Afhentning'} />
    <SideMenuItem to="/levering-afhentning/levering/fadoel" title="Levering af fadøl" active={activeSidemenu === 'LeveringFadoel'} />
    <SideMenuItem to="/levering-afhentning/vilkaar-fadoel" title="Vilkår for fadøl &amp; fadølsanlæg" active={activeSidemenu === 'Vilkaar'} />
    <SideMenuSpacer />
    <SideMenuItem to="/holdbarhed-paa-fadoel" title="Holdbarhed på fadøl" active={activeSidemenu === 'HoldbarhedFadoel'} />
    <SideMenuItem to="/forbrug-af-fadoel" title="Det drak andre kunder" active={activeSidemenu === 'DetDrakAndre'} />
    <SideMenuItem to="/fustager-forklaring-vejledning" title="Teknisk forklaring om fustager" active={activeSidemenu === 'TekniskFustage'} />
    <SideMenuItem to="/videoer" title="Videoer" active={activeSidemenu === 'Video'} />
    <SideMenuSpacer />
    <SideMenuItem to="/pant-og-returregler" title="Pant og returregler" active={activeSidemenu === 'PantReturregler'} />
    <SideMenuItem to="/holdbarhed-paa-flasker-daaser" title="Holdbarhed på flasker og dåser" active={activeSidemenu === 'HoldbarhedFlasker'} />
    <SideMenuItem to="/hjaelpemidler" title="Hjælpemidler til kasser" active={activeSidemenu === 'Hjaelpemidler'} />
    <SideMenuItem to="/plast-er-bedre-end-pap" title="Miljø: Plast er bedre end pap" active={activeSidemenu === 'PlastPap'} />
    <SideMenuItem to="/oekologiprocent" title="Økologiprocent" active={activeSidemenu === 'Oekologiprocent'} />
    <SideMenuSpacer />
    <SideMenuItem to="/betaling" title="Betal Faktura" active={activeSidemenu === 'Betal'} />
    <SideMenuItem to="/faq/faq" title="FAQ" active={activeSidemenu === 'FAQ'} />
  </Div>
);
